<h1 cds-text="title">View User</h1>
<app-user-summary *ngIf="!userRequestError" [user]="user"></app-user-summary>
<clr-alerts *ngIf="userRequestError">
  <clr-alert [clrAlertType]="'danger'" [clrAlertClosable]="false">
    <clr-alert-item>
      <span>Error: {{this.userRequestErrorMsg}}</span>
    </clr-alert-item>
  </clr-alert>
</clr-alerts>
